import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { Crown, Loader2 } from 'lucide-react';
import axios from 'axios';
import { API_URL } from '../config/api';

export default function PremiumSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isDark } = useTheme();
  const [status, setStatus] = useState('checking'); // checking, success, error
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (sessionId) {
      checkPayment(sessionId);
    } else {
      navigate('/app/premium');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkPayment = async (sessionId) => {
    try {
      const res = await axios.get(
        `${API_URL}/api/premium/checkout/status/${sessionId}`,
        { withCredentials: true }
      );
      
      if (res.data.payment_status === 'paid') {
        setStatus('success');
      } else if (attempts < 10) {
        // Keep polling
        setTimeout(() => {
          setAttempts(a => a + 1);
          checkPayment(sessionId);
        }, 2000);
      } else {
        setStatus('error');
      }
    } catch (err) {
      console.error('Payment check error:', err);
      if (attempts < 5) {
        setTimeout(() => {
          setAttempts(a => a + 1);
          checkPayment(sessionId);
        }, 2000);
      } else {
        setStatus('error');
      }
    }
  };

  if (status === 'checking') {
    return (
      <div className={`min-h-screen flex flex-col items-center justify-center p-4 ${isDark ? 'bg-[#080D1A]' : 'bg-gray-50'}`}>
        <Loader2 className="w-12 h-12 text-[#E8334A] animate-spin mb-4" />
        <h2 className={`text-xl font-semibold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Verifica pagamento...
        </h2>
        <p className={isDark ? 'text-white/60' : 'text-gray-500'}>
          Attendere prego
        </p>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className={`min-h-screen flex flex-col items-center justify-center p-4 ${isDark ? 'bg-[#080D1A]' : 'bg-gray-50'}`}>
        <div className={`max-w-sm w-full rounded-3xl p-8 text-center ${isDark ? 'bg-white/5' : 'bg-white'}`}>
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-red-100 flex items-center justify-center">
            <span className="text-4xl">😕</span>
          </div>
          <h2 className={`text-xl font-semibold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
            Qualcosa è andato storto
          </h2>
          <p className={`mb-6 ${isDark ? 'text-white/60' : 'text-gray-500'}`}>
            Non siamo riusciti a verificare il pagamento. Contatta il supporto se il problema persiste.
          </p>
          <button
            onClick={() => navigate('/app/premium')}
            className="w-full py-4 rounded-xl bg-[#E8334A] text-white font-semibold"
          >
            Torna a Premium
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`min-h-screen flex flex-col items-center justify-center p-4 ${isDark ? 'bg-[#080D1A]' : 'bg-gray-50'}`}>
      <div className={`max-w-sm w-full rounded-3xl p-8 text-center ${isDark ? 'bg-white/5' : 'bg-white'} shadow-xl`}>
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-[#E8334A] to-[#F59E0B] flex items-center justify-center animate-bounce">
          <Crown className="w-10 h-10 text-white" />
        </div>
        <h1 className={`text-2xl font-bold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Benvenuto in Premium! 🎉
        </h1>
        <p className={`mb-6 ${isDark ? 'text-white/60' : 'text-gray-500'}`}>
          Ora hai accesso a tutte le funzionalità esclusive di Slimmy
        </p>
        <button
          onClick={() => navigate('/app/dashboard')}
          className="w-full py-4 rounded-xl bg-[#E8334A] text-white font-semibold"
        >
          Inizia a esplorare
        </button>
      </div>
    </div>
  );
}
